module.exports = __webpack_public_path__ + "static/media/Empty.9e436403.svg";